import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import { useLocation } from 'js/lib/useRouter';

import ReviewsPageHeaderFooterWrapper from 'bundles/reviews/components/ReviewsPageHeaderFooterWrapper';
import { GlobalCoachChatStateProvider } from 'bundles/unified-common/providers/GlobalCoachChatStateProvider';
import NavAiSparkleExperimentProvider from 'bundles/unified-common/providers/NavAiSparkleExperimentProvider';
import UnifiedPageRolloutExperimentDataProvider from 'bundles/unified-description-page-common/providers/UnifiedPageRolloutExperimentDataProvider';

import 'css!bundles/reviews/styl/index';

const ReviewsApp = ({ children }: React.PropsWithChildren) => {
  const { pathname } = useLocation();
  const isEnterpriseReviewsPage = pathname.startsWith('/programs/') || pathname.startsWith('/organizations/');

  const pageContent = isEnterpriseReviewsPage ? (
    <ReviewsPageHeaderFooterWrapper>{children}</ReviewsPageHeaderFooterWrapper>
  ) : (
    <GlobalCoachChatStateProvider>
      <NavAiSparkleExperimentProvider>
        <ReviewsPageHeaderFooterWrapper>{children}</ReviewsPageHeaderFooterWrapper>
      </NavAiSparkleExperimentProvider>
    </GlobalCoachChatStateProvider>
  );

  return (
    <div className="rc-ReviewsApp">
      <UnifiedPageRolloutExperimentDataProvider>{pageContent}</UnifiedPageRolloutExperimentDataProvider>
    </div>
  );
};

export default compose<{}, React.PropsWithChildren>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'reviews',
      page: 'reviews',
    },
  }))
)(ReviewsApp);
